"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var TheLoading_vue_1 = __importDefault(require("./TheLoading.vue"));
var TheNavbar_vue_1 = __importDefault(require("./TheNavbar.vue"));
var store_1 = require("../store");
var vue_class_component_1 = __importStar(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var event_bus_1 = require("../event-bus");
var EchoMixin_1 = __importDefault(require("../mixins/request/EchoMixin"));
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "app";
        _this.fullScreen = false;
        return _this;
    }
    App.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.common.fullScreenWindow, this.updateFullScreen);
        this.echo.channel(this.echoChannels.setting)
            .listen(this.echoEvents.setting.update, this.updateSettings);
        this.$store.dispatch(store_1.Action.synchronizeAuthorizationStatus, {
            vue: this
        });
        this.$store.dispatch(store_1.Action.updateSettings, {
            settings: JSON.parse(this.settings)
        });
    };
    App.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.common.fullScreenWindow, this.updateFullScreen);
        this.echo.leave(this.echoChannels.setting);
    };
    App.prototype.updateSettings = function (settings) {
        this.$store.dispatch(store_1.Action.updateSettings, { settings: settings });
    };
    App.prototype.updateFullScreen = function (fullScreen) {
        if (fullScreen === void 0) { fullScreen = false; }
        this.fullScreen = fullScreen;
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], App.prototype, "settings", void 0);
    App = __decorate([
        vue_class_component_1.default({ components: {
                TheLoading: TheLoading_vue_1.default,
                TheNavbar: TheNavbar_vue_1.default
            } })
    ], App);
    return App;
}(vue_class_component_1.mixins(EchoMixin_1.default)));
exports.default = App;
